"use client";

import { Circle, Hexagon, Triangle } from "lucide-react";
import { useTranslations } from "next-intl";
import React, { type ReactElement } from "react";

function SitesPanelLegend(): ReactElement {
  const t = useTranslations("sites.PanelLegend");

  return (
    <div className="flex flex-col gap-4 pb-2">
      <div className="flex flex-col gap-1 text-accent-foreground">
        <h4 className="uppercase text-xs font-semibold">{t("legend")}</h4>
        <ul className="flex flex-col gap-1.5 rounded-lg p-2 border border-border">
          <li className="text-xs flex flex-row gap-2 items-center group">
            <Triangle className="w-4 h-4" />
            {t("station.description")}
          </li>
          <li className="text-xs flex flex-row gap-2 items-center group">
            <Circle className="w-4 h-4" />
            {t("point.description")}
          </li>
          <li className="text-xs flex flex-row gap-2 items-center group">
            <Hexagon className="w-4 h-4" />
            {t("zone.description")}
          </li>
        </ul>
      </div>
    </div>
  );
}

export { SitesPanelLegend };
